<template>
  <div class="key-account-details-container">
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
      <a-spin tip="Loading key account details..." />
    </div>
    <div v-else>
      <DetailsHeader :breadcrumbItems="keyAccountDetailsBreadcrumbs">
        <div
          style="
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 20px;
            margin-top: 20px;
          "
        >
          <p style="font-weight: bolder; margin: 0">
            {{ keyAccountDetails.companyName }}
          </p>
          <a-tag color="green"> ID: {{ keyAccountDetails.id }} </a-tag>
          <a-tag color="green">
            {{ keyAccountDetails.segmentType }}
          </a-tag>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 20px;
          "
        >
          <i class="fa fa-map-marker-alt" style="color: #26a246" />
          <p style="margin: 0">
            {{ keyAccountDetails.address.streetAddress }},
            {{ keyAccountDetails.address.city }}
          </p>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 20px;
          "
        >
          <i class="fa fa-phone-alt" style="color: #26a246" />
          <p style="margin: 0">{{ keyAccountDetails.primaryContact.phone }}</p>
        </div>
                 <div
           style="
             display: flex;
             align-items: center;
             gap: 8px;
             margin-bottom: 20px;
           "
         >
           <i class="fa fa-user-cog" style="color: #26a246" />
           <p style="margin: 0">
             <span style="font-size: small; color: #8c8c8c"
               >Account Manager:
             </span>
             {{ keyAccountDetails.accountManager }}
           </p>
         </div>
         <div
           style="
             display: flex;
             align-items: center;
             gap: 8px;
             margin-bottom: 20px;
           "
         >
           <i class="fa fa-wallet" style="color: #26a246" />
           <p style="margin: 0">
             <span style="font-size: small; color: #8c8c8c"
               >Wallet Status:
             </span>
             <StatusTag :status="getWalletStatus()" />
           </p>
         </div>
      </DetailsHeader>

      <div class="">
        <a-row :gutter="[24, 24]">
          <a-col :span="12">
            <a-card
              style="
                border-radius: 8px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 300px;
                border-radius: 16px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Primary Contact Information
              </h1>

              <div
                style="
                  display: flex;
                  align-items: start;
                  justify-content: space-between;
                "
              >
                <div style="display: flex; align-items: center; gap: 12px">
                  <a-avatar
                    size="large"
                    :style="{
                      backgroundColor: avatarColor,
                      verticalAlign: 'middle',
                      color: '#047857',
                    }"
                    :src="keyAccountDetails.primaryContact.profileImage || ''"
                    :alt="
                      keyAccountDetails.primaryContact.firstName +
                      ' ' +
                      keyAccountDetails.primaryContact.lastName
                    "
                    class="avatar"
                  >
                    {{
                      getInitials(
                        `${keyAccountDetails.primaryContact.firstName} ${keyAccountDetails.primaryContact.lastName}`
                      )
                    }}
                  </a-avatar>
                  <div
                    v-if="keyAccountDetails.primaryContact"
                    style="display: flex; flex-direction: column; gap: 8px"
                  >
                    <p>
                      {{ keyAccountDetails.primaryContact.title }}
                      {{ keyAccountDetails.primaryContact.firstName }}
                      {{ keyAccountDetails.primaryContact.lastName }}
                    </p>
                    <p>
                      {{ keyAccountDetails.primaryContact.designation }},
                      {{ keyAccountDetails.primaryContact.department }}
                    </p>
                    <p>
                      {{ keyAccountDetails.primaryContact.email }}
                    </p>
                  </div>
                </div>

                <div>
                  <p>Decision Maker</p>

                  <a-switch
                    :checked="
                      keyAccountDetails.primaryContact.isPrimaryDecisionMaker
                    "
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    style="background-color: #26a246; margin-top: 8px"
                  ></a-switch>
                </div>
              </div>

              <a-row
                :gutter="[16, 16]"
                style="margin-top: 20px; margin-bottom: 20px"
              >
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Phone</p>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <i class="fa fa-phone-alt" style="color: #26a246"></i>
                    <p style="font-weight: bolder !important; color: #000">
                      {{ keyAccountDetails.primaryContact.phone }}
                    </p>
                  </div>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Town</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.address.town || "N/A" }}
                  </p>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Sub Region</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.address.subRegion || "N/A" }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Region</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.address.region }}
                  </p>
                </a-col>
                                 <a-col :span="8">
                   <p style="margin-bottom: 8px">Country</p>
                   <p style="font-weight: bolder !important; color: #000">
                     {{ keyAccountDetails.address.country }}
                   </p>
                 </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 330px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Company Information
              </h1>

              <a-row
                :gutter="[16, 16]"
                style="margin-top: 20px; margin-bottom: 20px"
              >
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Company Name</p>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <p style="font-weight: bolder !important; color: #000">
                      {{ keyAccountDetails.companyName }}
                    </p>
                  </div>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Ownership Type</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.ownershipType }}
                  </p>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">No. of Employees</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.numberOfEmployees || "N/A" }}
                  </p>
                </a-col>
              </a-row>

                             <a-row :gutter="[16, 16]">
                 <a-col :span="8">
                   <p style="margin-bottom: 8px">Website</p>
                   <a 
                     v-if="keyAccountDetails.website" 
                     :href="keyAccountDetails.website" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     style="font-weight: bolder !important; color: #2563eb; word-wrap: break-word; overflow-wrap: break-word; max-width: 100%; text-decoration: underline; cursor: pointer;"
                   >
                     {{ keyAccountDetails.website }}
                   </a>
                   <p v-else style="font-weight: bolder !important; color: #000;">
                     N/A
                   </p>
                 </a-col>
                 <a-col :span="8">
                   <p style="margin-bottom: 8px">Customer Source</p>
                   <p style="font-weight: bolder !important; color: #000; word-wrap: break-word; overflow-wrap: break-word; max-width: 100%;">
                     {{ keyAccountDetails.customerSource }}
                   </p>
                 </a-col>
                 <a-col :span="8">
                   <p style="margin-bottom: 8px">Expected Revenue</p>
                   <p style="font-weight: bolder !important; color: #000">
                     {{ formatAmount(keyAccountDetails.expectedRevenue) }}
                   </p>
                 </a-col>
               </a-row>

            </a-card>
          </a-col>
        </a-row>
        <a-row :gutter="[24, 24]">
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 300px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Shipping Address
              </h1>

              <a-row :gutter="[16, 16]" style="margin: 20px auto !important">
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Address Line 1</p>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <p style="font-weight: bolder !important; color: #000">
                      {{
                        keyAccountDetails.shippingInformation.addressLine1 ||
                        "N/A"
                      }}
                    </p>
                  </div>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Address Line 2</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{
                      keyAccountDetails.shippingInformation.addressLine2 ||
                      "N/A"
                    }}
                  </p>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Country</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.shippingInformation.country || "N/A" }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Region</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.shippingInformation.region || "N/A" }}
                  </p>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Sub Region</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{
                      keyAccountDetails.shippingInformation.subRegion || "N/A"
                    }}
                  </p>
                </a-col>
                <a-col :span="8">
                  <p style="margin-bottom: 8px">Town</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ keyAccountDetails.shippingInformation.town || "N/A" }}
                  </p>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
        </a-row>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 24px">
        <a-button @click="goBack" class="back-button" :bordered="false">
          <a-icon type="arrow-left" /> Back to Key Account Catalog
        </a-button>
        
                 <a-button
           v-if="!isWalletLinked"
           :loading="createWalletLoading"
           @click="createWallet"
           style="border-radius: 6px; background: #26a246; color: #fff; border-color: #26a246"
           icon="wallet"
         >
           <a-spin v-if="createWalletLoading" size="small" style="margin-right: 8px;" />
           Create Wallet
         </a-button>
             </div>
     </div>

     <!-- Create Wallet Modal -->
     <a-modal
       :visible="createWalletModalVisible"
       title="Create Wallet"
       :footer="null"
       @cancel="handleCreateWalletModalCancel"
       :closable="true"
       :maskClosable="true"
       width="400px"
     >
       <div style="text-align: center; padding: 20px 0;">
         <div style="margin-bottom: 20px;">
           <i class="fa fa-credit-card" style="font-size: 48px; color: #26a246;"></i>
         </div>
         <h3 style="margin-bottom: 16px; color: #000; font-weight: 600;">Create Wallet</h3>
         <p style="color: #6b7280; margin-bottom: 24px; line-height: 1.5;">
           Are you sure you want to create a wallet for {{ companyName }}? 
           This action cannot be undone.
         </p>
         <div style="display: flex; gap: 12px; justify-content: center;">
           <a-button
             :loading="createWalletLoading"
             @click="confirmCreateWallet"
             style="background: #26a246; border-color: #26a246; color: #fff; border-radius: 6px;"
           >
             Create Wallet
           </a-button>
           <a-button
             @click="handleCreateWalletModalCancel"
             style="background: #fff; border-color: #d9d9d9; color: #666; border-radius: 6px;"
           >
             Cancel
           </a-button>
         </div>
       </div>
     </a-modal>
   </div>
 </template>

<script>
import { mapState } from "vuex";

import DetailsHeader from "../DetailsHeader.vue";
import StatusTag from "../../shared-components/StatusTag.vue";
import sellersService from "../../../api/sellers.service";
import { formatAmount, formatDate, getInitials } from "../../../utils";

export default {
  name: "KeyAccountDetails",
  components: {
    DetailsHeader,
    StatusTag,
  },
  props: {
    userSetupId: {
      type: String,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      createWalletLoading: false,
      createWalletModalVisible: false,
      keyAccountDetails: {},
      keyAccountFields: [
        { key: "companyName", label: "Company Name" },
        { key: "id", label: "Account ID" },
        {
          key: "primaryContact",
          label: "Primary Contact Person",
          formatter: (value) =>
            value
              ? `${value.title} ${value.firstName} ${value.lastName}`
              : "N/A",
        },
        {
          key: "primaryContact",
          label: "Contact Email",
          formatter: (value) => (value ? value.email : "N/A"),
        },
        {
          key: "primaryContact",
          label: "Contact Phone",
          formatter: (value) => (value ? value.phone : "N/A"),
        },
        { key: "segmentType", label: "Segment Type" },
        { key: "ownershipType", label: "Ownership Type" },
        { key: "numberOfEmployees", label: "Number of Employees" },
        { key: "website", label: "Website" },
        { key: "customerSource", label: "Customer Source" },
        {
          key: "expectedRevenue",
          label: "Expected Revenue",
          formatter: (value) => this.formatAmount(value),
        },
        {
          key: "address",
          label: "Address",
          formatter: (value) =>
            value
              ? `${value.streetAddress}, ${value.city}, ${value.region}, ${value.country}`
              : "N/A",
        },
        { key: "accountManager", label: "Account Manager" },
        { key: "status", label: "Status" },
        {
          key: "paymentTerms",
          label: "Payment Terms (days)",
          formatter: (value) => (value ? `${value} days` : "N/A"),
        },
        {
          key: "preferences",
          label: "Credit Limit",
          formatter: (value) =>
            this.formatAmount(value ? value.creditLimit : null),
        },
        {
          key: "preferences",
          label: "Enable Credit Hold",
          formatter: (value) =>
            value ? (value.enableCreditHold ? "Yes" : "No") : "N/A",
        },
        {
          key: "preferences",
          label: "Preferred Fulfillment Warehouse",
          formatter: (value) =>
            value ? value.preferredFulfillmentWarehouse : "N/A",
        },
        {
          key: "preferences",
          label: "Distribution Center",
          formatter: (value) => (value ? value.distributionCenter : "N/A"),
        },
        {
          key: "preferences",
          label: "Cold Chain Priority",
          formatter: (value) =>
            value ? (value.coldChainPriority ? "Yes" : "No") : "N/A",
        },
        {
          key: "shippingInformation",
          label: "Shipping Address",
          formatter: (value) =>
            value
              ? `${value.addressLine1}, ${value.town}, ${value.region}, ${value.country}`
              : "N/A",
        },
        {
          key: "createdAt",
          label: "Created At",
          formatter: (value) => (value ? this.formatDate(value) : "N/A"),
        },
        {
          key: "updatedAt",
          label: "Updated At",
          formatter: (value) => (value ? this.formatDate(value) : "N/A"),
        },
      ],
    };
  },
  computed: {
    ...mapState("sellerManagement", ["seller"]),
    keyAccountDetailsBreadcrumbs() {
      return [
        { text: "Seller Details", to: `/sellers/${this.userSetupId}` },
        { text: "Key Accounts", to: `/sellers/${this.userSetupId}?tab=5` },
        { text: "Key Account Details", to: null },
      ];
    },
    isWalletLinked() {
      return this.keyAccountDetails && this.keyAccountDetails.isWalletLinked;
    },
    companyName() {
      return this.keyAccountDetails && this.keyAccountDetails.companyName || 'this key account';
    },
  },
  async created() {
    await this.fetchKeyAccountDetails();
  },
  methods: {
    getInitials,
    async fetchKeyAccountDetails() {
      this.loading = true;
      try {
        const response = await sellersService.getKeyAccountDetails(
          this.accountId
        );
        if (response.data?.data) {
          this.keyAccountDetails = response.data.data;
        } else {
          this.$message.error("Failed to fetch key account details");
        }
      } catch (error) {
        console.error("Error fetching key account details:", error);
        this.$message.error("Failed to fetch key account details");
      } finally {
        this.loading = false;
      }
    },
    formatAmount,
    formatDate,
    goBack() {
      this.$router.push(`/sellers/${this.userSetupId}?tab=5`);
    },
    getWalletStatus() {
      return this.isWalletLinked ? "Active" : "Not Created";
    },
    createWallet() {
      this.createWalletModalVisible = true;
    },
    async confirmCreateWallet() {
      try {
        this.createWalletLoading = true;
        
        // Make API call to create Terra wallet using service
        const response = await sellersService.createKeyAccountWallet(this.accountId);
        
        if (response.data?.code === 200) {
          this.$message.success("Terra wallet created successfully");
          
          // Close modal
          this.createWalletModalVisible = false;
          
          // Emit event to parent to refresh data
          this.$emit('wallet-created');
          
          // Refresh key account details to update wallet status
          await this.fetchKeyAccountDetails();
        } else {
          this.$message.error(response.data?.message || "Failed to create wallet");
        }
        
      } catch (error) {
        console.error("Error creating wallet:", error);
        this.$message.error("Failed to create wallet. Please try again.");
      } finally {
        this.createWalletLoading = false;
      }
    },
    handleCreateWalletModalCancel() {
      this.createWalletModalVisible = false;
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #fff;
  padding: 32px 56px;
  border-radius: 16px;
  margin-bottom: 20px;
}
.key-account-details-container {
  padding: 24px;
  background-color: #f0f2f5;
  min-height: calc(
    100vh - 84px
  ); /* Adjust based on your header/footer height */
}

.avatar {
  background-color: #d1fae5;
  color: #047857;
  font-size: 14px;
  font-weight: bold;
}
p {
  margin: 0;
}

.back-button {
  background-color: #26a246;
  color: #fafafa;
  border-radius: 6px;
}
</style>
